"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenBurnTransaction = void 0;
const TransactionBuilder_1 = require("../TransactionBuilder");
const TokenBurn_pb_1 = require("../generated/TokenBurn_pb");
const TokenService_pb_service_1 = require("../generated/TokenService_pb_service");
const TokenId_1 = require("./TokenId");
const bignumber_js_1 = require("bignumber.js");
/**
 * Burns tokens from the Token's treasury Account. If no Supply Key is defined, the transaction will resolve to
 * TOKEN_HAS_NO_SUPPLY_KEY. The operation decreases the Total Supply of the Token. Total supply cannot go below zero.
 * The amount provided must be in the lowest denomination possible. Example:
 * Token A has 2 decimals. In order to burn 100 tokens, one must provide amount of 10000. In order to burn 100.55
 * tokens, one must provide amount of 10055.
 */
class TokenBurnTransaction extends TransactionBuilder_1.SingleTransactionBuilder {
    constructor() {
        super();
        this._body = new TokenBurn_pb_1.TokenBurnTransactionBody();
        this._inner.setTokenburn(this._body);
    }
    /**
     * The token for which to burn tokens. If token does not exist, transaction results in INVALID_TOKEN_ID
     */
    setTokenId(id) {
        this._body.setToken(new TokenId_1.TokenId(id)._toProto());
        return this;
    }
    /**
     * The amount to burn from the Treasury Account. Amount must be a positive non-zero number, not bigger than the
     * token balance of the treasury account (0; balance], represented in the lowest denomination.
     */
    setAmount(amount) {
        this._body.setAmount((amount instanceof bignumber_js_1.default ?
            amount :
            new bignumber_js_1.default(amount)).toString());
        return this;
    }
    get _method() {
        return TokenService_pb_service_1.TokenService.burnToken;
    }
    _doValidate(_) { }
}
exports.TokenBurnTransaction = TokenBurnTransaction;
